import { FC } from 'react'

import { routes } from 'commons/constants/routes'
import { IconSize } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { DateTime } from 'ui/components/DateTime'
import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'
import { Link } from 'ui/components/Link'
import { TextMask } from 'ui/components/TextMask'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { GeneralInformationProps } from './GeneralInformationProps'

import * as SC from './styles'

export const GeneralInformation: FC<GeneralInformationProps> = ({
  data: {
    company: { id, name },
    number = '',
    active = false,
    openingDate = '',
    showClosingDate,
    internalTransferType,
    updatedAt = '',
    createdAt = '',
    notes,
    licenses
  }
}) => (
  <InfoSet direction={InfoSetDirection.COLUMN}>
    <FormRow>
      <Col>
        <Info label="Relationship Name">
          <Link to={routes.bank.relationships.details} params={{ id: id.toString() }}>
            {name}
          </Link>
        </Info>
      </Col>
      <Col>
        <Info label="Account Number">
          <TextMask isBankAccount text={number} iconSize={IconSize.XS} />
        </Info>
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Info label="Active">
          <div style={{ width: '20px' }}>
            <CheckMark value={active} label="" rounded={false} />
          </div>
        </Info>
      </Col>
      <Col>
        <Info label="Opening Date">
          <DateTime date={openingDate} />
        </Info>
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Info label="Participation in the Transfers program">{internalTransferType}</Info>
      </Col>
      {showClosingDate && (
        <Col>
          <Info label="Closing Date">
            <DateTime date={showClosingDate} />
          </Info>
        </Col>
      )}
    </FormRow>
    <FormRow>
      <Col>
        <Info label="Created At">
          <DateTime date={createdAt} withTime />
        </Info>
      </Col>
      <Col>
        <Info label="Last Modified At">
          <DateTime date={updatedAt} withTime />
        </Info>
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Info label="Notes">{notes}</Info>
      </Col>
    </FormRow>
    {licenses?.length > 0 && (
      <>
        <SC.WrappedHr />
        <Info label={<>Licenses ({(licenses || []).length})</>}>
          {licenses?.map((license, index) => {
            const { id, number, name } = license

            return (
              <SC.License key={index}>
                <Link to="/licenses/$licenseId" params={{ licenseId: id.toString() }}>{`${name} (${number})`}</Link>
              </SC.License>
            )
          })}
        </Info>
      </>
    )}
  </InfoSet>
)
